/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
import { COLORS } from '@lemonade-hq/tokens';
import { lerp } from '@lemonade-hq/ts-helpers';

export const TEXT =
  '3,800 meals sent to homebound elderly New Yorkers in need. 460 families in underserved communities giving safe housing in the U.S. 542 homeless NYC youth given STEM programming and college & career resource. 4,277 meals from rescued food provided to people in need. 107,570 meals distributed to local food banks throughout the U.S. 100 vulnerable school children in Somalia fed nutritious meals for 4 months. 2 homes built for individuals living in extreme poverty in El Salvador. 16 midwives trained in countries like Ethiopia. 16,000 nutritional meals distributed to people in need throughout France. 3,717 WASH workshops given to students in Ghana, Guatemala and Laos. 10,000 pounds of litter removed from beaches. 57,897 trees planted in the mountain forest in Michoacán, Mexico. 42,725 tons of CO2 emissions averted. 1,200 trees planted in the Sierra Gorda Biosphere, a declared UNESCO site. 1 Environmental Justice Fund sponsored, and 5,000 ecological restoration projects supported. 9 water projects given funding, providing clean and safe drinking water to 3,000 people in Mali. 5,686 pounds of plastic cleared from oceans worldwide. 1.15 million teachers provided with Next Generation Ocean Education resources. 500 climate groups supported in the fight for climate justice. 1,500 Bay Area youth were educated about environmental equity. 22 trees planted in a ‘food forest’ near Amsterdam to improve biodiversity. 164,000 children educated to target plastic pollution. 2,000 primary school children in Zanzibar taught about the environment. 20,408 animals across the globe given food, care, and shelter. 1 Chimpanzee Rehabilitation Project given funding. 2 Bald Eagles sponsored. 357 hours of the world’s most promising breast cancer research funded. 275 children with cancer given treatment. 100 Ukrainian refugees provided with emergency medical backpacks. 78 mammograms administered. 250 new moms trained in CPR. 975 Blood Donors tested for Sickle Cell disease. 1 rare cancer trial researched at Memorial Sloan Kettering. 488 displaced children from Ukraine sent emergency water, sanitation and hygiene kits. 20 individuals provided housing in a trans-identifying safe home. 1,100 LGBTQ youth given lifesaving mental health services. 18 members of the LGBTQ+ community in D.R. Congo supplied with overnight accommodations. 20 Support sessions given to LGBTQ+ victims of abuse. 8,500 hours of mentoring granted to students in systemically under-resourced schools. 4,732 teachers sponsored in high-need communities across the U.S. 8 individuals with intellectual and developmental disabilities trained in public speaking and self-advocacy. 40 stipends provided for Black, Indigenous, Latinx, and Pacific Islander youth and adult storytellers. 100 girls in Herat, Afghanistan given free coding courses. 16,355 vulnerable girls enrolled to stay in school across the Sidama Region of Ethiopia. 2 ACLU initiatives (the Reproductive Freedom Project and the Anti-Racism Project) funded. 250,000 pledges to vote before the 2022 midterm elections secured. 2,000 kids protected from child trafficking and online abuse. 138 foster kids given brand new duffle bags, hygiene kits, and toys. 15 days of culinary training provided for refugee chefs. 3 journalists reimbursed for medical fees. 6 months of funding for a 24/7 confidential helpline in Bulgaria and Greece to combat human trafficking. 14,000 veterans given mental health support. 517 people accessed a support counselor for the first time. 300,000 young women and adolescent girls provided free and accessible mental health resources. 7 children granted a full year of weekly therapy to help them heal from physical abuse. 101 volunteers for the NAMI HelpLine funded to support those in crisis.';

const LGBTQ_TEXT =
  '20 individuals provided housing in a trans-identifying safe home. 1,100 LGBTQ youth given lifesaving mental health services. 18 members of the LGBTQ+ community in D.R. Congo supplied with overnight accommodations. 20 Support sessions given to LGBTQ+ victims of abuse.';
const LGBTQ_START_INDEX = TEXT.indexOf(LGBTQ_TEXT) + 1;
const LGBTQ_END_INDEX = LGBTQ_START_INDEX + LGBTQ_TEXT.length;

const ENVIRONMENT_TEXT =
  '10,000 pounds of litter removed from beaches. 57,897 trees planted in the mountain forest in Michoacán, Mexico. 42,725 tons of CO2 emissions averted. 1,200 trees planted in the Sierra Gorda Biosphere, a declared UNESCO site. 1 Environmental Justice Fund sponsored, and 5,000 ecological restoration projects supported. 9 water projects given funding, providing clean and safe drinking water to 3,000 people in Mali. 5,686 pounds of plastic cleared from oceans worldwide. 1.15 million teachers provided with Next Generation Ocean Education resources. 500 climate groups supported in the fight for climate justice. 1,500 Bay Area youth were educated about environmental equity. 22 trees planted in a ‘food forest’ near Amsterdam to improve biodiversity. 164,000 children educated to target plastic pollution. 2,000 primary school children in Zanzibar taught about the environment.';
const ENVIRONMENT_START_INDEX = TEXT.indexOf(ENVIRONMENT_TEXT) + 1;
const ENVIRONMENT_END_INDEX = ENVIRONMENT_START_INDEX + ENVIRONMENT_TEXT.length;

const CIVIL_RIGHTS_TEXT =
  '2 ACLU initiatives (the Reproductive Freedom Project and the Anti-Racism Project) funded. 250,000 pledges to vote before the 2022 midterm elections secured. 2,000 kids protected from child trafficking and online abuse. 138 foster kids given brand new duffle bags, hygiene kits, and toys. 15 days of culinary training provided for refugee chefs. 3 journalists reimbursed for medical fees. 6 months of funding for a 24/7 confidential helpline in Bulgaria and Greece to combat human trafficking.';
const CIVIL_RIGHTS_START_INDEX = TEXT.indexOf(CIVIL_RIGHTS_TEXT) + 1;
const CIVIL_RIGHTS_END_INDEX = CIVIL_RIGHTS_START_INDEX + CIVIL_RIGHTS_TEXT.length;

export const PHRASES = [
  '3,800 meals',
  '460 families',
  '542 homeless NYC youth',
  '4,277 meals',
  '107,570 meals',
  '100 vulnerable school children',
  '2 homes',
  '16 midwives',
  '16,000 nutritional meals',
  '3,717 WASH workshops',
  '10,000 pounds of litter',
  '57,897 trees',
  '42,725 tons of CO2',
  '1,200 trees',
  '1 Environmental Justice Fund',
  '5,000 ecological restoration projects',
  '9 water projects',
  '5,686 pounds of plastic',
  '1.15 million teachers',
  '500 climate groups',
  '1,500 Bay Area youth',
  '22 trees',
  '164,000 children',
  '2,000 primary school children',
  '20,408 animals',
  '1 Chimpanzee',
  '2 Bald Eagles',
  '357 hours',
  '275 children',
  '100 Ukrainian refugees',
  '78 mammograms',
  '250 new moms',
  '975 Blood Donors',
  '1 rare cancer trial',
  '488 displaced children',
  '20 individuals',
  '1,100 LGBTQ youth',
  '18 members',
  '20 Support sessions',
  '8,500 hours',
  '4,732 teachers',
  '8 individuals',
  '40 stipends',
  '100 girls',
  '16,355 vulnerable girls',
  '2 ACLU initiatives',
  '250,000 pledges',
  '2,000 kids',
  '138 foster kids',
  '15 days',
  '3 journalists',
  '6 months',
  '14,000 veterans',
  '517 people',
  '300,000 young women',
  '7 children',
  '101 volunteers',
];

export const PHRASES_INDICES = PHRASES.reduce<number[]>((result, phrase) => {
  const index = TEXT.indexOf(phrase);
  for (let i = 0; i < phrase.length; i++) {
    result.push(index + i);
  }

  return result;
}, []);

export const SNAKE_LENGTH = 58;
export const TEXT_ARRAY = TEXT.split('');
export const CLASS_NAME = 'giveback-2022-content-container';

const generateCssSelector = (snakeIndex: number, from: number, to: number): string => {
  return `.${CLASS_NAME} :nth-child(n + ${Math.max(
    from,
    snakeIndex,
  )}):not(:nth-child(n + ${Math.min(snakeIndex + SNAKE_LENGTH, to)}))`;
};

export const generateEnvironmentStyle = (snakeIndex: number): string => {
  if (snakeIndex + SNAKE_LENGTH < ENVIRONMENT_START_INDEX || snakeIndex > ENVIRONMENT_END_INDEX) return '';

  return `${generateCssSelector(
    snakeIndex,
    ENVIRONMENT_START_INDEX,
    ENVIRONMENT_END_INDEX,
  )} { color: ${COLORS.green};}`;
};

export const generateCivilRightsStyle = (snakeIndex: number): string => {
  if (snakeIndex + SNAKE_LENGTH < CIVIL_RIGHTS_START_INDEX || snakeIndex > CIVIL_RIGHTS_END_INDEX) return '';

  return `${generateCssSelector(
    snakeIndex,
    CIVIL_RIGHTS_START_INDEX,
    CIVIL_RIGHTS_END_INDEX,
  )} { color: ${COLORS.white}; background: ${
    COLORS.darkerNight
  }; box-shadow: 3px 0 0 rgb(40, 40, 40); animation: none; }`;
};

export const generateLgbtqStyle = (snakeIndex: number): string => {
  let result = '';

  if (snakeIndex + SNAKE_LENGTH < LGBTQ_START_INDEX || snakeIndex > LGBTQ_END_INDEX) return '';

  const startPosition = Math.max(snakeIndex, LGBTQ_START_INDEX);
  const endPosition = Math.min(snakeIndex + SNAKE_LENGTH, LGBTQ_END_INDEX);
  for (let i = startPosition; i < endPosition; i++) {
    result += `.${CLASS_NAME}.${CLASS_NAME} :nth-child(${i}){ color: ${`hsl(${Math.floor(
      lerp(0, 360 * 2, i / SNAKE_LENGTH),
    )}deg 75% 51%)`};}`;
  }

  return result;
};

export const generateSnakeStyle = (snakeIndex: number): string => {
  const snakeStartPosition = snakeIndex < 0 ? 0 : snakeIndex;
  const snakeEndPosition =
    snakeIndex < 0 ? snakeIndex + SNAKE_LENGTH - Math.abs(snakeStartPosition) : snakeIndex + SNAKE_LENGTH;

  return `.${CLASS_NAME} :nth-child(n + ${snakeStartPosition}):not(:nth-child(n + ${snakeEndPosition})) {
        color: ${COLORS.pink};
    }  
`;
};

export const generateRestAnimationStyle = (snakeIndex: number): string => {
  let result = '';

  for (let i = snakeIndex; i < snakeIndex + SNAKE_LENGTH; i++) {
    result += `.${CLASS_NAME} :nth-child(${i}){
            animation: pulse 3s infinite ease-in-out;
            animation-delay: ${(i - snakeIndex) * 50}ms;
            transform-origin: bottom;
        }`;
  }

  return result;
};
